// extracted by mini-css-extract-plugin
module.exports = {"slidingPanel":"SlidingPanel_slidingPanel__2Q1SJ","isVisibleSlidingPanel":"SlidingPanel_isVisibleSlidingPanel___byqh","content":"SlidingPanel_content__3beN2"};